import { render, staticRenderFns } from "./supplierManageList.vue?vue&type=template&id=30f38c84&scoped=true"
import script from "./supplierManageList.vue?vue&type=script&lang=js"
export * from "./supplierManageList.vue?vue&type=script&lang=js"
import style0 from "./supplierManageList.vue?vue&type=style&index=0&id=30f38c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f38c84",
  null
  
)

export default component.exports